import { useMatch } from "react-router";
import { ChatThreadSupport } from "./components/ChatThreadSupport";
import { IntercomChatSupport } from "./components/IntercomChatSupport";
import { ChatGeneralSupport } from "./components/ChatGeneralSupport";

const CHAT_THREAD_PATH = "/chat/:threadId";

export const ChatSupport = () => {
  const matchThreadId = useMatch(CHAT_THREAD_PATH);

  return (
    <>
      <IntercomChatSupport />
      {matchThreadId ? (
        <ChatThreadSupport threadId={matchThreadId.params.threadId ?? ""} />
      ) : (
        <ChatGeneralSupport />
      )}
    </>
  );
};
